/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1AccessRefreshtoken200,
  PostApiV1AccessRefreshtoken400,
  PostApiV1AccessRefreshtoken401,
  PostApiV1AccessRefreshtoken500,
  PostApiV1AccessRefreshtokenMutationResponse,
} from "../../types/accessController/PostApiV1AccessRefreshtoken.ts";
import { loginResultViewModelSchema } from "../loginResultViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1AccessRefreshtoken200Schema = z.lazy(
  () => loginResultViewModelSchema,
) as unknown as ToZod<PostApiV1AccessRefreshtoken200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1AccessRefreshtoken400Schema =
  z.any() as unknown as ToZod<PostApiV1AccessRefreshtoken400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1AccessRefreshtoken401Schema =
  z.any() as unknown as ToZod<PostApiV1AccessRefreshtoken401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1AccessRefreshtoken500Schema =
  z.any() as unknown as ToZod<PostApiV1AccessRefreshtoken500>;

export const postApiV1AccessRefreshtokenMutationResponseSchema = z.lazy(
  () => postApiV1AccessRefreshtoken200Schema,
) as unknown as ToZod<PostApiV1AccessRefreshtokenMutationResponse>;
